import React, { useEffect } from 'react'
import { useHookstate } from '@hookstate/core'
import CrudIndex from '~/components/CrudIndex'
import Layout from '~/components/Layout'
import { useLang } from '~/hooks/useLang'
import CategoryViewMore from '../Components/ViewMore'

export default function Index() {
  const { translate } = useLang()
  const name = useHookstate<string | null>(null)
  const forceRefresh = useHookstate(false)

  useEffect(() => {
    document.title = translate('Administration - Dispatch System')
  }, [])

  const categoryFilters = [
    {
      name: 'name',
      type: 'name',
      placeholder: translate('Name'),
      variable: name,
    },
  ]

  return (
    <Layout marginLayout={true}>
      <CrudIndex
        model="category"
        title="Categoria de Tipo e Subtipo"
        createTitleComplete="Categoria de Tipo e Subtipo"
        disableColumnsFilters
        forceOrderColumns={['name']}
        exceptColumns={['id', 'updated_at', 'deleted_at', 'created_by_user_id', 'updated_by_user_id']}
        aliasLabel={[{ column: 'name', label: 'Nome' }]}
        filters={categoryFilters}
        searchButton={() => forceRefresh.set(!forceRefresh.get())}
        forceRefresh={forceRefresh.get()}
        clearFilters={() => {
          name.set(null)
          forceRefresh.set(!forceRefresh.get())
        }}
        canView={true}
        viewTitle="Categoria de Tipo e Subtipo"
        customViewMoreComponent={CategoryViewMore}
      />
    </Layout>
  )
}